import sys from './system';

import './styles/styles.less';
import './files';

import services from './services';
import VueSmoothScroll from 'vue3-smooth-scroll';
import components from './components';

services(sys.framework);
sys.configure((app) => {
    app.use(VueSmoothScroll);
});
sys.configure(components);

export default sys;
